module.exports = __webpack_public_path__ + "img/1.94bc394e.jpg";